import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ClerkProvider } from "@clerk/clerk-react";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

const clerkKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const clerkAppearance = {
  variables: {
    colorBackground: "#0F1318",
    colorPrimary: "#45E0BD",
    colorText: "#F4F2EC",
    colorTextSecondary: "#A5ADB8",
    colorInputBackground: "#090B0E",
    colorInputText: "#F4F2EC",
    colorNeutral: "#F4F2EC",
    borderRadius: "0px",
    fontFamily: "'IBM Plex Sans', sans-serif",
  },
  elements: {
    card: { border: "1px solid #29313B", boxShadow: "none", background: "#0F1318" },
    headerTitle: { color: "#F4F2EC" },
    formButtonPrimary: { background: "#aadb3c", color: "#11150b", textTransform: "none" },
    footerActionLink: { color: "#45E0BD" },
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={clerkKey}
      appearance={clerkAppearance}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInForceRedirectUrl="/app"
      signUpForceRedirectUrl="/onboarding/business"
      afterSignOutUrl="/"
    >
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ClerkProvider>
  </React.StrictMode>
);
